export const removeAllHtmltags = (originalString: string) =>
  originalString.replace(/(<([^>]+)>)/gi, '');
